import { MenuItem, TextField } from "@mui/material";
import type { SpanStatisticsBaselineWindow } from "../../api/client";

export interface BaselineSelectorProps {
  value: SpanStatisticsBaselineWindow;
  onChange: (value: SpanStatisticsBaselineWindow) => void;
  label?: string;
}

function formatBaselineShortLabel(v: SpanStatisticsBaselineWindow): string {
  switch (v) {
    case "1h":
      return "1 hour";
    case "24h":
      return "24 hours";
    case "7d":
      return "7 days";
    case "30d":
      return "30 days";
  }
}

export function BaselineSelector({ value, onChange, label = "Baseline" }: BaselineSelectorProps) {
  return (
    <TextField
      select
      size="small"
      label={label}
      value={value}
      onChange={(e) => onChange(e.target.value as SpanStatisticsBaselineWindow)}
    >
      {(["1h", "24h", "7d", "30d"] as const).map((v) => (
        <MenuItem key={v} value={v}>
          {formatBaselineShortLabel(v)}
        </MenuItem>
      ))}
    </TextField>
  );
}
